export default function () {
    String.prototype.reSpace = function () {
        return decodeURIComponent(encodeURIComponent(this).replace(/%C2%A0/g, ' '));
    };

    String.prototype.trimAll = function () {
        return this.replace(/\s/g, '');
    };

    String.prototype.byteLength = function () {
        let sum = 0;// 总字符长度
        for (let i = 0; i < this.length; i++) {
            if ((this.charCodeAt(i) >= 0) && (this.charCodeAt(i) <= 255)) {
                sum = sum + 1;
            } else {
                sum = sum + 2;
            }
        }
        return sum;
    };
}
